import Route from '@ember/routing/route'
import type RouterService from '@ember/routing/router-service'
import { service } from '@ember/service'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type ApplicationRoute from 'teacher-ui-client/application/route'

/**
 * This route's job is to handle the initial 'landing' of the user, sending them to the subscription type area that
 * they're likely wanting to use - for example, if the user only has a valid maths sub, they'll be sent to the maths
 * area.
 *
 * The authorization of the users' subscriptions are conducted in the subscription-type route.
 *
 * If they have no utilisations to indicate preference, they'll still be redirected to subscription-type route, but
 * using the first valid sub type, where they'll likely be greeted with a "start new trial" or "access expired" page
 */
export default class extends Route {
  @service router!: RouterService

  beforeModel() {
    const { subscriptionUtilisations } = this.modelFor('application') as ModelFor<ApplicationRoute>

    // Redirect to the first valid subscription type that the user has a utilisation for (in this order)
    const validSubTypes = Object.values(SubscriptionType)
    const firstSubscription = validSubTypes.find((validSubType) => {
      return Boolean(subscriptionUtilisations.find((util) => util.subscriptionType === validSubType))
    })

    if (firstSubscription) {
      void this.router.replaceWith('subscription-type.home', firstSubscription)
    } else {
      // No valid sub utilisation found.
      // take them to one of the areas - the actual subscription will be checked on the subscription-type route.
      void this.router.replaceWith('subscription-type.home', validSubTypes[0])
    }
  }
}
